export class PcMarkupEcommerce {
   public pcMarkupEcommerce: number;
}
